module.exports = __webpack_public_path__ + "static/sizzle_mobile-f7820529d54c883c99a00bc3d53ce633.mp4";